import React from "react";
import styled from "styled-components";
import ContentLoader from "react-content-loader";
import { borders } from "@sonder/ui/source/styled/theme";

const StyledHeaderContentLoader = styled(ContentLoader)`
  border-bottom: ${borders.standard};
  height: 180px;
  width: 436px;
`;

export const HeaderContentLoader = () => (
  <StyledHeaderContentLoader height={180} width={436}>
    <path d="M277 158H240V170H277V158Z" fill="black" />
    <path d="M78 158H25V170H78V158Z" fill="black" />
    <path d="M153 158H100V170H153V158Z" fill="black" />
    <path d="M217 158H176V170H217V158Z" fill="black" />
    <path d="M280 106H218V118H280V106Z" fill="black" />
    <path
      d="M193.5 121C198.747 121 203 116.747 203 111.5C203 106.253 198.747 102 193.5 102C188.253 102 184 106.253 184 111.5C184 116.747 188.253 121 193.5 121Z"
      fill="black"
    />
    <path d="M155 114H65V125H155V114Z" fill="black" />
    <path d="M118 97H65V108H118V97Z" fill="black" />
    <path
      d="M40 126C48.2843 126 55 119.284 55 111C55 102.716 48.2843 96 40 96C31.7157 96 25 102.716 25 111C25 119.284 31.7157 126 40 126Z"
      fill="black"
    />
    <path d="M139 57H26V70H139V57Z" fill="black" />
    <path d="M181 22H26V36H181V22Z" fill="black" />
  </StyledHeaderContentLoader>
);
